var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import ResponsiveTable from "../UI/ResponsiveTable/ResponsiveTable";
import useService from "./useService";
import ServiceResult, { Loaders } from "../UI/ServiceResult/ServiceResult";
import Pager from "../UI/Pager/Pager";
export const TotalPageMappers = {
    EngagePagedResult: (pagedResult, pageSize) => Math.ceil(pagedResult.total / pageSize),
    PagedInfo: (info) => info.totalPages,
};
function usePagedSortedTable(_a) {
    var { searchArgs, initialSort, columnsThatCantSort, getData, getNumPages, columns, rows, addCheckboxes, addMarginToPager } = _a, responsiveTableProps = __rest(_a, ["searchArgs", "initialSort", "columnsThatCantSort", "getData", "getNumPages", "columns", "rows", "addCheckboxes", "addMarginToPager"]);
    const [dataState, loadData] = useService(React.useState(() => getData)[0]);
    const [sort, setSort] = React.useState(initialSort || null);
    const [page, setPage] = React.useState(0);
    const [isRefreshing, setIsRefreshing] = React.useState(false);
    const [hasEverBeenManuallyRefreshed, setHasEverBeenManuallyRefreshed] = React.useState(false);
    React.useEffect(() => {
        setPage(0);
    }, [searchArgs]);
    React.useEffect(() => {
        setIsRefreshing(false);
        loadData(sort, page, searchArgs, false);
    }, [loadData, page, searchArgs, sort]);
    const refresh = React.useCallback(() => {
        setHasEverBeenManuallyRefreshed(true);
        setIsRefreshing(true);
        return loadData(sort, page, searchArgs, true);
    }, [loadData, page, searchArgs, sort]);
    let initialSortColumn = null;
    // @ts-expect-error - TS7034 - Variable 'initialSortDirection' implicitly has type 'any' in some locations where its type cannot be determined.
    let initialSortDirection = null;
    if (initialSort) {
        if (initialSort.order === "asc") {
            initialSortDirection = "asc";
        }
        else {
            initialSortDirection = "desc";
        }
        if (typeof initialSort.sort === "number") {
            initialSortColumn = initialSort.sort;
        }
        else {
            const index = columns.findIndex((column) => column.sortId === initialSort.sort);
            if (index >= 0) {
                initialSortColumn = index;
            }
        }
    }
    const table = (_jsx(ServiceResult, { loader: Loaders.overlay(), state: dataState, children: (data) => {
            const calcRows = rows(data);
            return (_jsxs(_Fragment, { children: [_jsx("div", { children: _jsx(ResponsiveTable, Object.assign({}, responsiveTableProps, { addCheckboxes: addCheckboxes
                                ? {
                                    useCheckboxesMakeCheckbox: addCheckboxes.useCheckboxesMakeCheckbox,
                                    ids: calcRows === null || calcRows === void 0 ? void 0 : calcRows.map((_, i) => addCheckboxes.getCheckedItem(data, i)),
                                }
                                : undefined, initialSortColumn: initialSortColumn, 
                            // @ts-expect-error - TS7005 - Variable 'initialSortDirection' implicitly has an 'any' type.
                            initialSortDirection: initialSortDirection, columns: columns.map((column, i) => {
                                const { sortId } = column, otherColumnProps = __rest(column, ["sortId"]);
                                return Object.assign(Object.assign({}, otherColumnProps), { onSort: !sortId || (columnsThatCantSort || []).includes(i)
                                        ? undefined
                                        : (order) => {
                                            if (order === null) {
                                                setSort(null);
                                            }
                                            else {
                                                setSort({ sort: sortId, order });
                                            }
                                        } });
                            }), rows: calcRows })) }), _jsx(Pager, { className: classNames("mt-3", { "ml-3": addMarginToPager }), setCurrentPage: setPage, totalPages: getNumPages(data), currentPage: page })] }));
        } }));
    return {
        table,
        refresh,
        dataState,
        isManuallyRefreshing: dataState.isLoading && isRefreshing,
        hasEverBeenManuallyRefreshed,
    };
}
export default usePagedSortedTable;
